import {
  CurrentWhitelistFromApi,
  WhitelistVersionFromApi,
} from '@/services/singleWhitelistApi';

// Types for UI components
export interface CurrentWhitelist {
  id: number;
  filename: string;
  uploadedBy: string;
  uploadDate: Date;
  size: number;
  contentType: string;
  fileUrl: string; // deprecated - will be removed
  userId: string;
  lastVersionId: number;
}

export interface WhitelistVersion {
  id: number;
  filename: string;
  uploadedBy: string;
  uploadDate: Date;
  size: number;
  contentType: string;
  fileUrl: string; // deprecated - will be removed
}

/**
 * Transform current whitelist API response to component format
 */
export function transformCurrentWhitelistFromApi(
  apiData: CurrentWhitelistFromApi
): CurrentWhitelist {
  // Safely construct user name
  const firstName = apiData.user?.first_name || '';
  const lastName = apiData.user?.last_name || '';
  const fullName = `${firstName} ${lastName}`.trim();
  const uploadedBy = fullName || apiData.user?.email || 'Unknown User';

  // Safely parse date
  let uploadDate: Date;
  try {
    uploadDate = new Date(apiData.created_at);
    if (isNaN(uploadDate.getTime())) {
      uploadDate = new Date();
    }
  } catch {
    uploadDate = new Date();
  }

  return {
    id: apiData.id,
    filename: apiData.filename || 'Unknown File',
    uploadedBy,
    uploadDate,
    size: apiData.size || 0,
    contentType: apiData.content_type || 'application/octet-stream',
    fileUrl: '', // deprecated - will be removed
    userId: apiData.user_id || '',
    lastVersionId: apiData.last_version_id || apiData.id, // fallback to id if last_version_id not available (swagger doesn't show this field yet)
  };
}

/**
 * Transform whitelist version API response to component format
 */
export function transformWhitelistVersionFromApi(
  apiData: WhitelistVersionFromApi
): WhitelistVersion {
  // Safely construct user name
  const firstName = apiData.created_by?.first_name || '';
  const lastName = apiData.created_by?.last_name || '';
  const fullName = `${firstName} ${lastName}`.trim();
  const uploadedBy = fullName || apiData.created_by?.email || 'Unknown User';

  // Safely parse date
  let uploadDate: Date;
  try {
    uploadDate = new Date(apiData.created_at);
    if (isNaN(uploadDate.getTime())) {
      uploadDate = new Date();
    }
  } catch {
    uploadDate = new Date();
  }

  return {
    id: apiData.id,
    filename: apiData.filename || 'Unknown File',
    uploadedBy,
    uploadDate,
    size: apiData.size || 0,
    contentType: apiData.content_type || 'application/octet-stream',
    fileUrl: '', // deprecated - will be removed
  };
}

/**
 * Transform array of version API responses to component format
 */
export function transformWhitelistVersionsFromApi(
  apiData: WhitelistVersionFromApi[]
): WhitelistVersion[] {
  if (!apiData || !Array.isArray(apiData)) {
    return [];
  }

  return apiData.map(transformWhitelistVersionFromApi);
}
